var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCreditCard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1000005088"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 23141",
    d: "M0 2.24031C0 1.17993 0.859613 0.320312 1.92 0.320312H22.08C23.1404 0.320312 24 1.17993 24 2.24031V13.7603C24 14.8207 23.1404 15.6803 22.08 15.6803H1.92C0.859613 15.6803 0 14.8207 0 13.7603V2.24031Z",
    fill: "#E2E8F3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 23142",
    d: "M1.91992 3.6802C1.91992 3.4151 2.13483 3.2002 2.39992 3.2002H7.67992C7.94502 3.2002 8.15992 3.4151 8.15992 3.6802V7.0402C8.15992 7.30529 7.94502 7.5202 7.67992 7.5202H2.39992C2.13483 7.5202 1.91992 7.30529 1.91992 7.0402V3.6802Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 23143",
    x: 1.91992,
    y: 10.8799,
    width: 4.32,
    height: 1.92,
    fill: "#A5B4CF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 23144",
    x: 7.2002,
    y: 10.8799,
    width: 4.32,
    height: 1.92,
    fill: "#A5B4CF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 23145",
    x: 12.4805,
    y: 10.8799,
    width: 4.32,
    height: 1.92,
    fill: "#A5B4CF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 23146",
    x: 17.7598,
    y: 10.8799,
    width: 4.32,
    height: 1.92,
    fill: "#A5B4CF"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCard);
export default __webpack_public_path__ + "static/media/credit-card.bfc79d55dbcbd703b1a8b17feac483e8.svg";
export { ForwardRef as ReactComponent };